// extracted by mini-css-extract-plugin
export var dropdownContainer = "_md-0";
export var leftAlign = "_md-4";
export var listItem = "_md-2";
export var listItemWrapper = "_md-1";
export var operationText = "_md-3";